import React from 'react'
import ReactMarkdown from 'react-markdown'
import classNames from 'classnames'
import { Section } from '../../../../index'

const ServiceIntro = ({ content: { markdown, metadata } }) => (
  <Section
    className={classNames('services-intro', metadata ? metadata.className : '')}
    innerClassName="services-intro__wrapper"
    isCentered
  >
    <section className="services-intro__content">
      <ReactMarkdown escapeHtml={false} source={markdown.content} />
      <hr />
    </section>
  </Section>
)

export default ServiceIntro
